var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoTrenitaliaIcn = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 60, height: 18, viewBox: "0 0 60 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18.3877 0L11.7924 17.9958H7L13.5992 0H18.3877Z", fill: "black" }),
            React.createElement("path", { d: "M35.5468 0L33.9105 4.49798L23.7851 4.49933C23.4915 4.49933 23.0813 4.6209 22.7559 4.92046C22.4306 5.22003 22.2468 5.5181 22.0518 6.01791C21.725 6.85559 21.2952 7.86998 20.8786 9.02022C20.5513 9.92404 20.2546 10.9039 19.8719 12.0007C19.7042 12.4813 19.7555 12.8281 19.8719 13.0538C19.9882 13.2795 20.5652 13.4779 21.2193 13.498C21.585 13.5092 24.7232 13.511 30.634 13.5034L29.5477 16.4975C29.3116 17.0539 29.1026 17.5547 28.9206 18L19.3529 17.9973C17.098 17.9973 15.3436 17.5788 14.8536 16.4975C14.2533 15.1732 14.7025 14.0034 14.8536 13.498L14.9179 13.3064C15.3297 12.1296 17.4012 6.63994 18.3907 4.268C19.0322 2.71808 19.4527 1.79534 19.6523 1.49978C20.1675 0.557015 21.1914 0.0824208 22.3368 0.00986864L22.6518 0H35.5468Z", fill: "black" }),
            React.createElement("path", { d: "M43.9764 11.9108L48.346 0H53.1345L46.5392 17.9958L41.746 17.9939L39.6052 6.49058L35.3899 17.9958H30.5975L37.1967 0H41.9852L43.9764 11.9108Z", fill: "black" }))),
        alt: 'Trenitalia Icn',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoTrenitaliaIcn;
//# sourceMappingURL=index.js.map